/**
 * AB实验工具函数
 */
export { buildCalculateAbResultParams } from './buildAbParams';

/**
 * 处理地区和国家选择器数据
 * @param result - getSelector 接口返回的数据
 * @returns 处理后的地区和国家数据
 */
export function processCountrySelectorData(result: any): {
  regionCountries: any[];
  popularList: string[];
} {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { area_list = [], key_country_list = [] } = result || {};
  const newRegionCountries: any[] = [];

  // eslint-disable-next-line @typescript-eslint/naming-convention
  area_list?.forEach((area: any) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { area_code, area_name_ch, area_name_en, country_set = [] } = area || {};
    if (area_code === 'All Areas' || area_code === 'GLOBAL') {
      return;
    }

    const newArea = {
      region_abbre: area_code?.toLowerCase() || '',
      region_key: area_code,
      region_name_cn: area_name_ch,
      region_name_en: area_name_en,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      country: country_set?.map((country: any) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { country_code, country_name_ch, country_name_en, deviation } = country || {};
        return {
          country_name_abbre: country_code,
          country_name_cn: country_name_ch,
          country_name_en,
          deviation,
        };
      }),
    };
    newRegionCountries.push(newArea);
  });

  newRegionCountries.sort((a, b) => a?.region_name_en?.localeCompare(b?.region_name_en));

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const newPopularList = key_country_list?.map((country: any) => country.country_code) || [];

  return {
    regionCountries: newRegionCountries,
    popularList: newPopularList,
  };
}
